import { UIDialog } from 'src/components/ui/Modal'
import Text from 'src/components/ui/Text'
import {
  hasPromptHelperEnabledHintShownToday,
  resetPromptHelperLastShownTime,
} from '../utils/promptHelperHint'

export const openPromptsHelperEnabledHintDialog = (reason?: string) => {
  // Show once per day
  if (!hasPromptHelperEnabledHintShownToday()) {
    resetPromptHelperLastShownTime()

    return UIDialog.alert({
      dismissable: true,
      heading: (
        <Text i18nKey="generation:prompt-helper.force-enable-dialog.heading" />
      ),
      content: (
        <Text
          i18nKey="generation:prompt-helper.force-enable-dialog.content"
          context={reason}
        />
      ),
    })
  }
}
